import { render, staticRenderFns } from "./SalabamWiaggiare.vue?vue&type=template&id=df4e853a&scoped=true"
import script from "./SalabamWiaggiare.vue?vue&type=script&lang=js"
export * from "./SalabamWiaggiare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4e853a",
  null
  
)

export default component.exports